var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup1212(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Group_1212",
    "data-name": "Group 1212",
    width: 681.511,
    height: 730.105,
    viewBox: "0 0 681.511 730.105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_408",
    "data-name": "Rectangle 408",
    width: 681.511,
    height: 730.105,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_364",
    "data-name": "Rectangle 364",
    width: 655.868,
    height: 569.412,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_366",
    "data-name": "Rectangle 366",
    width: 144.715,
    height: 8.298,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_367",
    "data-name": "Rectangle 367",
    width: 101.997,
    height: 8.298,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_368",
    "data-name": "Rectangle 368",
    width: 73.057,
    height: 8.298,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_369",
    "data-name": "Rectangle 369",
    width: 85.126,
    height: 8.298,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_370",
    "data-name": "Rectangle 370",
    width: 139.674,
    height: 48.877,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_372",
    "data-name": "Rectangle 372",
    width: 71.19,
    height: 8.299,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_373",
    "data-name": "Rectangle 373",
    width: 28.47,
    height: 8.298,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_374",
    "data-name": "Rectangle 374",
    width: 59.114,
    height: 72.902,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_375",
    "data-name": "Rectangle 375",
    width: 49.619,
    height: 142.886,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_376",
    "data-name": "Rectangle 376",
    width: 40.047,
    height: 118.627,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_377",
    "data-name": "Rectangle 377",
    width: 53.163,
    height: 24.726,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_378",
    "data-name": "Rectangle 378",
    width: 135.963,
    height: 43.596,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1211",
    "data-name": "Group 1211",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1172",
    "data-name": "Group 1172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1171",
    "data-name": "Group 1171",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1170",
    "data-name": "Group 1170",
    transform: "translate(21.181)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1169",
    "data-name": "Group 1169"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1168",
    "data-name": "Group 1168",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1645",
    "data-name": "Path 1645",
    d: "M656.138,349.487c-20.781,53.888-63.243,112.211-122.993,129.48-90.282,26.1-101.067,96.554-262.773,90.02a336.3,336.3,0,0,1-69.924-9.927,278,278,0,0,1-32.876-10.587C73.1,511.428,23.826,429.9,19.735,344.589c-5.4-112.2,75.46-165.678,128.011-196.992S263.636-5.051,422.654.164a325.849,325.849,0,0,1,71.874,10.164c53.507,14.02,107.9,45.03,139.506,90.365q3.559,5.107,6.8,10.442c42.3,69.479,43.634,164.886,15.3,238.352",
    transform: "translate(-19.477 0)",
    fill: "#ff6d0c"
  })))))), /*#__PURE__*/React.createElement("line", {
    id: "Line_53",
    "data-name": "Line 53",
    x1: 281.831,
    transform: "translate(49.898 584.99)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1210",
    "data-name": "Group 1210"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1209",
    "data-name": "Group 1209",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_54",
    "data-name": "Line 54",
    x1: 328.059,
    transform: "translate(352.909 584.99)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1646",
    "data-name": "Path 1646",
    d: "M450.9,178.354V424.139a23.182,23.182,0,0,1-23.184,23.173H89.684A23.175,23.175,0,0,1,66.5,424.139V178.354A23.184,23.184,0,0,1,89.684,155.17H427.717A23.191,23.191,0,0,1,450.9,178.354",
    transform: "translate(5.815 13.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1647",
    "data-name": "Path 1647",
    d: "M450.9,178.354V424.139a23.182,23.182,0,0,1-23.184,23.173H89.684A23.175,23.175,0,0,1,66.5,424.139V178.354A23.184,23.184,0,0,1,89.684,155.17H427.717A23.191,23.191,0,0,1,450.9,178.354Z",
    transform: "translate(5.815 13.569)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1648",
    "data-name": "Path 1648",
    d: "M424.855,437.337H91.535A19.274,19.274,0,0,1,72.26,418.063V214.218a19.274,19.274,0,0,1,19.275-19.274h333.32a19.274,19.274,0,0,1,19.275,19.274V418.063a19.274,19.274,0,0,1-19.275,19.274",
    transform: "translate(6.319 17.047)",
    fill: "#eeebef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1649",
    "data-name": "Path 1649",
    d: "M96.14,175.553a7.477,7.477,0,1,1-7.477-7.477,7.477,7.477,0,0,1,7.477,7.477",
    transform: "translate(7.099 14.698)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1650",
    "data-name": "Path 1650",
    d: "M118.493,175.553a7.477,7.477,0,1,1-7.477-7.477,7.477,7.477,0,0,1,7.477,7.477",
    transform: "translate(9.054 14.698)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1651",
    "data-name": "Path 1651",
    d: "M140.847,175.553a7.477,7.477,0,1,1-7.477-7.477,7.477,7.477,0,0,1,7.477,7.477",
    transform: "translate(11.009 14.698)",
    fill: "#eeebef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1652",
    "data-name": "Path 1652",
    d: "M160.465,227.853H99.088a4.149,4.149,0,1,1,0-8.3h61.378a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(8.302 19.199)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1653",
    "data-name": "Path 1653",
    d: "M342.367,227.853H305.9a4.149,4.149,0,0,1,0-8.3h36.47a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(26.387 19.199)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1175",
    "data-name": "Group 1175",
    transform: "translate(178.168 238.754)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1174",
    "data-name": "Group 1174"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1173",
    "data-name": "Group 1173",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1654",
    "data-name": "Path 1654",
    d: "M304.408,227.853H167.991a4.149,4.149,0,1,1,0-8.3H304.408a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(-163.841 -219.555)",
    fill: "#4e3057"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1655",
    "data-name": "Path 1655",
    d: "M140.736,247H99.087a4.149,4.149,0,1,1,0-8.3h41.649a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(8.302 20.874)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1656",
    "data-name": "Path 1656",
    d: "M162.539,266.153H111.182a4.149,4.149,0,1,1,0-8.3h51.357a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(9.36 22.548)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1657",
    "data-name": "Path 1657",
    d: "M209.452,266.153H170.87a4.149,4.149,0,1,1,0-8.3h38.583a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(14.579 22.548)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1658",
    "data-name": "Path 1658",
    d: "M257.3,266.153H218.812a4.149,4.149,0,1,1,0-8.3H257.3a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(18.771 22.548)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1659",
    "data-name": "Path 1659",
    d: "M276.141,266.153h-9.473a4.149,4.149,0,1,1,0-8.3h9.473a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(22.956 22.548)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1660",
    "data-name": "Path 1660",
    d: "M162.539,285.3H111.182a4.149,4.149,0,1,1,0-8.3h51.357a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(9.36 24.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1661",
    "data-name": "Path 1661",
    d: "M187.781,285.3H170.87a4.149,4.149,0,1,1,0-8.3h16.911a4.149,4.149,0,0,1,0,8.3",
    transform: "translate(14.579 24.223)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1662",
    "data-name": "Path 1662",
    d: "M329.307,285.3H322.9a4.149,4.149,0,1,1,0-8.3h6.406a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(27.874 24.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1663",
    "data-name": "Path 1663",
    d: "M212.947,285.3H198.881a4.149,4.149,0,0,1,0-8.3h14.066a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(17.029 24.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1178",
    "data-name": "Group 1178",
    transform: "translate(239.376 301.228)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1177",
    "data-name": "Group 1177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1176",
    "data-name": "Group 1176",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1664",
    "data-name": "Path 1664",
    d: "M317.974,285.3h-93.7a4.149,4.149,0,1,1,0-8.3h93.7a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(-220.127 -277.005)",
    fill: "#4e3057"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1665",
    "data-name": "Path 1665",
    d: "M140.736,304.453H99.087a4.149,4.149,0,1,1,0-8.3h41.649a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(8.302 25.898)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1666",
    "data-name": "Path 1666",
    d: "M160.465,323.777H99.088a4.149,4.149,0,1,1,0-8.3h61.378a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(8.302 27.587)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1667",
    "data-name": "Path 1667",
    d: "M276.47,323.777H240a4.149,4.149,0,0,1,0-8.3h36.47a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(20.624 27.587)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1181",
    "data-name": "Group 1181",
    transform: "translate(178.168 343.066)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1180",
    "data-name": "Group 1180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1179",
    "data-name": "Group 1179",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1668",
    "data-name": "Path 1668",
    d: "M232.748,323.777H167.99a4.149,4.149,0,0,1,0-8.3h64.758a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(-163.841 -315.479)",
    fill: "#4e3057"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1669",
    "data-name": "Path 1669",
    d: "M140.736,342.927H99.087a4.149,4.149,0,1,1,0-8.3h41.649a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(8.302 29.262)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1670",
    "data-name": "Path 1670",
    d: "M162.539,362.077H111.182a4.149,4.149,0,1,1,0-8.3h51.357a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(9.36 30.937)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1671",
    "data-name": "Path 1671",
    d: "M209.452,362.077H170.87a4.149,4.149,0,1,1,0-8.3h38.583a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(14.579 30.937)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1672",
    "data-name": "Path 1672",
    d: "M257.3,362.077H218.812a4.149,4.149,0,1,1,0-8.3H257.3a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(18.771 30.937)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1673",
    "data-name": "Path 1673",
    d: "M276.141,362.077h-9.473a4.149,4.149,0,1,1,0-8.3h9.473a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(22.956 30.937)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1674",
    "data-name": "Path 1674",
    d: "M162.539,381.227H111.182a4.149,4.149,0,1,1,0-8.3h51.357a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(9.36 32.611)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1675",
    "data-name": "Path 1675",
    d: "M187.781,381.227H170.87a4.149,4.149,0,1,1,0-8.3h16.911a4.149,4.149,0,0,1,0,8.3",
    transform: "translate(14.579 32.611)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1676",
    "data-name": "Path 1676",
    d: "M325.386,381.227h-18a4.149,4.149,0,0,1,0-8.3h18a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(26.517 32.611)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1677",
    "data-name": "Path 1677",
    d: "M212.947,381.227H198.881a4.149,4.149,0,0,1,0-8.3h14.066a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(17.029 32.611)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1184",
    "data-name": "Group 1184",
    transform: "translate(239.376 405.54)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1183",
    "data-name": "Group 1183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1182",
    "data-name": "Group 1182",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1678",
    "data-name": "Path 1678",
    d: "M301.1,381.227H224.277a4.149,4.149,0,1,1,0-8.3H301.1a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(-220.127 -372.929)",
    fill: "#4e3057"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1679",
    "data-name": "Path 1679",
    d: "M140.736,400.377H99.087a4.149,4.149,0,1,1,0-8.3h41.649a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(8.302 34.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1187",
    "data-name": "Group 1187",
    transform: "translate(317.037 279.791)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1186",
    "data-name": "Group 1186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1185",
    "data-name": "Group 1185",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1680",
    "data-name": "Path 1680",
    d: "M291.543,257.292v26.487a22.391,22.391,0,0,0,22.391,22.391H431.217V257.292Z",
    transform: "translate(-291.543 -257.292)",
    fill: "#4e3057"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1681",
    "data-name": "Path 1681",
    d: "M506.988,295.784H295a23.18,23.18,0,0,1-23.18-23.181V131.858A23.18,23.18,0,0,1,295,108.677h211.99a23.181,23.181,0,0,1,23.181,23.181V272.6a23.181,23.181,0,0,1-23.181,23.181",
    transform: "translate(23.769 9.503)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_371",
    "data-name": "Rectangle 371",
    d: "M21.317,0H237.035a21.316,21.316,0,0,1,21.316,21.316V165.79a21.317,21.317,0,0,1-21.317,21.317H21.317A21.317,21.317,0,0,1,0,165.79V21.317A21.317,21.317,0,0,1,21.317,0Z",
    transform: "translate(295.587 118.181)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1682",
    "data-name": "Path 1682",
    d: "M504.127,285.806H296.851a19.275,19.275,0,0,1-19.275-19.275V167.724a19.275,19.275,0,0,1,19.275-19.275H504.127A19.275,19.275,0,0,1,523.4,167.724v98.808a19.275,19.275,0,0,1-19.275,19.275",
    transform: "translate(24.273 12.981)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1683",
    "data-name": "Path 1683",
    d: "M301.456,129.058a7.477,7.477,0,1,1-7.477-7.477,7.477,7.477,0,0,1,7.477,7.477",
    transform: "translate(25.054 10.632)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1684",
    "data-name": "Path 1684",
    d: "M323.81,129.058a7.477,7.477,0,1,1-7.477-7.477,7.477,7.477,0,0,1,7.477,7.477",
    transform: "translate(27.008 10.632)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1685",
    "data-name": "Path 1685",
    d: "M346.164,129.058a7.477,7.477,0,1,1-7.477-7.477,7.477,7.477,0,0,1,7.477,7.477",
    transform: "translate(28.963 10.632)",
    fill: "#eeebef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1686",
    "data-name": "Path 1686",
    d: "M365.782,181.358H304.4a4.149,4.149,0,1,1,0-8.3h61.379a4.149,4.149,0,0,1,0,8.3",
    transform: "translate(26.256 15.133)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1687",
    "data-name": "Path 1687",
    d: "M480.071,181.358H443.6a4.149,4.149,0,0,1,0-8.3h36.47a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(38.428 15.133)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1190",
    "data-name": "Group 1190",
    transform: "translate(401.439 188.193)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1189",
    "data-name": "Group 1189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1188",
    "data-name": "Group 1188",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1688",
    "data-name": "Path 1688",
    d: "M436.2,181.358H373.307a4.149,4.149,0,1,1,0-8.3H436.2a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(-369.158 -173.06)",
    fill: "#eeebef"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1689",
    "data-name": "Path 1689",
    d: "M346.053,200.509H304.4a4.149,4.149,0,1,1,0-8.3h41.649a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(26.256 16.808)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1690",
    "data-name": "Path 1690",
    d: "M367.856,219.659H316.5a4.149,4.149,0,1,1,0-8.3h51.357a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(27.314 18.483)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1691",
    "data-name": "Path 1691",
    d: "M414.769,219.659H376.187a4.149,4.149,0,1,1,0-8.3h38.583a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(32.533 18.483)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1692",
    "data-name": "Path 1692",
    d: "M431.109,219.659h-6.981a4.149,4.149,0,1,1,0-8.3h6.981a4.149,4.149,0,0,1,0,8.3",
    transform: "translate(36.725 18.483)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1693",
    "data-name": "Path 1693",
    d: "M452.48,219.659h-9.473a4.149,4.149,0,1,1,0-8.3h9.473a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(38.376 18.483)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1694",
    "data-name": "Path 1694",
    d: "M367.856,238.809H316.5a4.149,4.149,0,1,1,0-8.3h51.357a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(27.314 20.157)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1695",
    "data-name": "Path 1695",
    d: "M393.1,238.809h-16.91a4.149,4.149,0,1,1,0-8.3H393.1a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(32.533 20.157)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1696",
    "data-name": "Path 1696",
    d: "M467.011,238.809H460.6a4.149,4.149,0,1,1,0-8.3h6.406a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(39.915 20.157)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1697",
    "data-name": "Path 1697",
    d: "M418.264,238.809H404.2a4.149,4.149,0,0,1,0-8.3h14.066a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(34.983 20.157)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1193",
    "data-name": "Group 1193",
    transform: "translate(462.647 250.668)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1192",
    "data-name": "Group 1192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1191",
    "data-name": "Group 1191",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1698",
    "data-name": "Path 1698",
    d: "M449.766,238.809H429.594a4.149,4.149,0,1,1,0-8.3h20.172a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(-425.444 -230.511)",
    fill: "#eeebef"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1699",
    "data-name": "Path 1699",
    d: "M346.053,257.959H304.4a4.149,4.149,0,1,1,0-8.3h41.649a4.149,4.149,0,1,1,0,8.3",
    transform: "translate(26.256 21.832)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1196",
    "data-name": "Group 1196",
    transform: "translate(72.315 387.979)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1195",
    "data-name": "Group 1195"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1194",
    "data-name": "Group 1194",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1700",
    "data-name": "Path 1700",
    d: "M76.341,361.075a48.945,48.945,0,0,0-9.841-4.3v49.729a23.175,23.175,0,0,0,23.184,23.173h35.929c-5.774-28.4-24.033-54.231-49.272-68.607",
    transform: "translate(-66.5 -356.78)",
    fill: "#4e3057"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1199",
    "data-name": "Group 1199",
    transform: "translate(96.871 317.995)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1198",
    "data-name": "Group 1198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1197",
    "data-name": "Group 1197",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1701",
    "data-name": "Path 1701",
    d: "M125.868,382.265c6.981-21.477,8.319-46.195,1.664-67.737-1.957-6.34-4.633-12.723-9.537-17.193s-12.506-6.546-18.345-3.4c-5.753,3.088-8.178,10.015-9.33,16.442a81.458,81.458,0,0,0,7.493,50.795c5.611,11.059,14.952,21.923,27.284,21.966,2.555,10.3,5.263,21.27,8.014,32.678,1.588,6.655,3.121,13.169,4.567,19.5H138.7q-2.186-9.608-4.6-19.737c-2.816-11.647-5.589-22.826-8.232-33.308",
    transform: "translate(-89.081 -292.424)",
    fill: "#4e3057"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1202",
    "data-name": "Group 1202",
    transform: "translate(155.026 342.254)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1201",
    "data-name": "Group 1201"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1200",
    "data-name": "Group 1200",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1702",
    "data-name": "Path 1702",
    d: "M162.645,314.752c-6.851.435-10.722,7.928-12.777,14.474-10.711,34.168-9.8,71.391,3.741,104.134h21.879a64.275,64.275,0,0,0,5.763-23.826c1.62-26.621,3.186-53.861-4.165-79.492-2.1-7.308-6.851-15.768-14.441-15.289",
    transform: "translate(-142.56 -314.732)",
    fill: "#4e3057"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1205",
    "data-name": "Group 1205",
    transform: "translate(215.695 436.155)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1204",
    "data-name": "Group 1204"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1203",
    "data-name": "Group 1203",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1703",
    "data-name": "Path 1703",
    d: "M248.829,404.016c-4.252-4.361-11.483-3.132-17.182-.99a86.569,86.569,0,0,0-33.3,22.782h47.739a44.926,44.926,0,0,0,2.947-5.046c2.675-5.339,3.958-12.473-.207-16.747",
    transform: "translate(-198.35 -401.082)",
    fill: "#4e3057"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1704",
    "data-name": "Path 1704",
    d: "M370.012,553.548H607.074a16.311,16.311,0,0,0,16.312-16.312V220.331a16.311,16.311,0,0,0-16.312-16.312H521.581",
    transform: "translate(32.356 17.841)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1705",
    "data-name": "Path 1705",
    d: "M246.82,494.555H206.214A16.312,16.312,0,0,1,189.9,478.243V423.82",
    transform: "translate(16.606 37.061)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1208",
    "data-name": "Group 1208",
    transform: "translate(289.877 417.286)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1207",
    "data-name": "Group 1207"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1206",
    "data-name": "Group 1206",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1706",
    "data-name": "Path 1706",
    d: "M397.365,413.178V423.27h.087a5.088,5.088,0,0,1,4.98,4.056H266.665a5.088,5.088,0,0,1,4.98-4.056h.087V413.178h-.087a5.068,5.068,0,0,1-5.078-5.068v-19.3a5.077,5.077,0,0,1,5.078-5.078H397.452a5.077,5.077,0,0,1,5.078,5.078v19.3a5.068,5.068,0,0,1-5.078,5.068Z",
    transform: "translate(-266.567 -383.73)",
    fill: "#4e3057"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_379",
    "data-name": "Rectangle 379",
    width: 5.165,
    height: 13.655,
    transform: "translate(399.785 564.561)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_380",
    "data-name": "Rectangle 380",
    width: 5.165,
    height: 13.655,
    transform: "translate(399.785 564.561)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_381",
    "data-name": "Rectangle 381",
    width: 5.165,
    height: 13.655,
    transform: "translate(399.785 483.742)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_382",
    "data-name": "Rectangle 382",
    width: 5.165,
    height: 13.655,
    transform: "translate(399.785 483.742)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_383",
    "data-name": "Rectangle 383",
    width: 5.165,
    height: 13.655,
    transform: "translate(260.844 524.79)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_384",
    "data-name": "Rectangle 384",
    width: 5.165,
    height: 13.655,
    transform: "translate(260.844 524.79)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1707",
    "data-name": "Path 1707",
    d: "M375.055,365.447H249.241a5.074,5.074,0,0,0-5.073,5.073v19.3a5.073,5.073,0,0,0,5.073,5.073H375.055a5.072,5.072,0,0,0,5.073-5.073v-19.3a5.073,5.073,0,0,0-5.073-5.073",
    transform: "translate(21.352 31.957)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_385",
    "data-name": "Rectangle 385",
    width: 135.96,
    height: 29.449,
    rx: 4.665,
    transform: "translate(265.52 397.404)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1708",
    "data-name": "Path 1708",
    d: "M342.685,372.355H251.379a1.2,1.2,0,0,0-1.2,1.2v12.025a1.2,1.2,0,0,0,1.2,1.2h91.305a1.2,1.2,0,0,0,1.2-1.2V373.554a1.2,1.2,0,0,0-1.2-1.2",
    transform: "translate(21.877 32.561)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_386",
    "data-name": "Rectangle 386",
    width: 93.704,
    height: 14.424,
    rx: 1.103,
    transform: "translate(272.058 404.916)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1709",
    "data-name": "Path 1709",
    d: "M351.947,378.7a3.634,3.634,0,1,0-3.634,3.634,3.635,3.635,0,0,0,3.634-3.634",
    transform: "translate(30.141 32.798)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1710",
    "data-name": "Path 1710",
    d: "M351.947,378.7a3.634,3.634,0,1,0-3.634,3.634A3.635,3.635,0,0,0,351.947,378.7Z",
    transform: "translate(30.141 32.798)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1711",
    "data-name": "Path 1711",
    d: "M365.035,378.7a3.634,3.634,0,1,0-3.634,3.634,3.635,3.635,0,0,0,3.634-3.634",
    transform: "translate(31.285 32.798)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1712",
    "data-name": "Path 1712",
    d: "M365.035,378.7a3.634,3.634,0,1,0-3.634,3.634A3.635,3.635,0,0,0,365.035,378.7Z",
    transform: "translate(31.285 32.798)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1713",
    "data-name": "Path 1713",
    d: "M332.454,378.7a3.634,3.634,0,1,0-3.635,3.634,3.635,3.635,0,0,0,3.635-3.634",
    transform: "translate(28.436 32.798)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1714",
    "data-name": "Path 1714",
    d: "M332.454,378.7a3.634,3.634,0,1,0-3.635,3.634A3.635,3.635,0,0,0,332.454,378.7Z",
    transform: "translate(28.436 32.798)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_387",
    "data-name": "Rectangle 387",
    width: 125.641,
    height: 10.085,
    transform: "translate(270.679 426.853)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_388",
    "data-name": "Rectangle 388",
    width: 125.641,
    height: 10.085,
    transform: "translate(270.679 426.853)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1715",
    "data-name": "Path 1715",
    d: "M375.055,401.8H249.241a5.073,5.073,0,0,0-5.073,5.073v19.3a5.073,5.073,0,0,0,5.073,5.073H375.055a5.072,5.072,0,0,0,5.073-5.073v-19.3a5.073,5.073,0,0,0-5.073-5.073",
    transform: "translate(21.352 35.136)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_389",
    "data-name": "Rectangle 389",
    width: 135.96,
    height: 29.449,
    rx: 4.665,
    transform: "translate(265.52 436.938)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1716",
    "data-name": "Path 1716",
    d: "M342.685,408.71H251.379a1.2,1.2,0,0,0-1.2,1.2v12.025a1.2,1.2,0,0,0,1.2,1.2h91.305a1.2,1.2,0,0,0,1.2-1.2V409.909a1.2,1.2,0,0,0-1.2-1.2",
    transform: "translate(21.877 35.74)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_390",
    "data-name": "Rectangle 390",
    width: 93.704,
    height: 14.424,
    rx: 1.103,
    transform: "translate(272.058 444.451)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1717",
    "data-name": "Path 1717",
    d: "M351.947,415.057a3.634,3.634,0,1,0-3.634,3.634,3.634,3.634,0,0,0,3.634-3.634",
    transform: "translate(30.141 35.977)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1718",
    "data-name": "Path 1718",
    d: "M351.947,415.057a3.634,3.634,0,1,0-3.634,3.634A3.634,3.634,0,0,0,351.947,415.057Z",
    transform: "translate(30.141 35.977)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1719",
    "data-name": "Path 1719",
    d: "M365.035,415.057a3.634,3.634,0,1,0-3.634,3.634,3.634,3.634,0,0,0,3.634-3.634",
    transform: "translate(31.285 35.977)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1720",
    "data-name": "Path 1720",
    d: "M365.035,415.057a3.634,3.634,0,1,0-3.634,3.634A3.634,3.634,0,0,0,365.035,415.057Z",
    transform: "translate(31.285 35.977)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1721",
    "data-name": "Path 1721",
    d: "M332.454,415.057a3.634,3.634,0,1,0-3.635,3.634,3.634,3.634,0,0,0,3.635-3.634",
    transform: "translate(28.436 35.977)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1722",
    "data-name": "Path 1722",
    d: "M332.454,415.057a3.634,3.634,0,1,0-3.635,3.634A3.634,3.634,0,0,0,332.454,415.057Z",
    transform: "translate(28.436 35.977)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_391",
    "data-name": "Rectangle 391",
    width: 125.641,
    height: 10.085,
    transform: "translate(270.679 466.387)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_392",
    "data-name": "Rectangle 392",
    width: 125.641,
    height: 10.085,
    transform: "translate(270.679 466.387)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1723",
    "data-name": "Path 1723",
    d: "M375.055,438.157H249.241a5.073,5.073,0,0,0-5.073,5.073v19.3a5.073,5.073,0,0,0,5.073,5.073H375.055a5.072,5.072,0,0,0,5.073-5.073v-19.3a5.073,5.073,0,0,0-5.073-5.073",
    transform: "translate(21.352 38.315)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_393",
    "data-name": "Rectangle 393",
    width: 135.96,
    height: 29.449,
    rx: 4.665,
    transform: "translate(265.52 476.472)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1724",
    "data-name": "Path 1724",
    d: "M342.685,445.065H251.379a1.2,1.2,0,0,0-1.2,1.2v12.025a1.2,1.2,0,0,0,1.2,1.2h91.305a1.2,1.2,0,0,0,1.2-1.2V446.264a1.2,1.2,0,0,0-1.2-1.2",
    transform: "translate(21.877 38.919)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_394",
    "data-name": "Rectangle 394",
    width: 93.704,
    height: 14.424,
    rx: 1.103,
    transform: "translate(272.058 483.985)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1725",
    "data-name": "Path 1725",
    d: "M351.947,451.412a3.634,3.634,0,1,0-3.634,3.634,3.634,3.634,0,0,0,3.634-3.634",
    transform: "translate(30.141 39.156)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1726",
    "data-name": "Path 1726",
    d: "M351.947,451.412a3.634,3.634,0,1,0-3.634,3.634A3.634,3.634,0,0,0,351.947,451.412Z",
    transform: "translate(30.141 39.156)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1727",
    "data-name": "Path 1727",
    d: "M365.035,451.412a3.634,3.634,0,1,0-3.634,3.634,3.634,3.634,0,0,0,3.634-3.634",
    transform: "translate(31.285 39.156)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1728",
    "data-name": "Path 1728",
    d: "M365.035,451.412a3.634,3.634,0,1,0-3.634,3.634A3.634,3.634,0,0,0,365.035,451.412Z",
    transform: "translate(31.285 39.156)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1729",
    "data-name": "Path 1729",
    d: "M332.454,451.412a3.634,3.634,0,1,0-3.635,3.634,3.634,3.634,0,0,0,3.635-3.634",
    transform: "translate(28.436 39.156)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1730",
    "data-name": "Path 1730",
    d: "M332.454,451.412a3.634,3.634,0,1,0-3.635,3.634A3.634,3.634,0,0,0,332.454,451.412Z",
    transform: "translate(28.436 39.156)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_395",
    "data-name": "Rectangle 395",
    width: 125.641,
    height: 10.085,
    transform: "translate(270.679 505.921)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_396",
    "data-name": "Rectangle 396",
    width: 125.641,
    height: 10.085,
    transform: "translate(270.679 505.921)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1731",
    "data-name": "Path 1731",
    d: "M375.055,474.512H249.241a5.074,5.074,0,0,0-5.073,5.073v19.3a5.073,5.073,0,0,0,5.073,5.073H375.055a5.072,5.072,0,0,0,5.073-5.073v-19.3a5.073,5.073,0,0,0-5.073-5.073",
    transform: "translate(21.352 41.494)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_397",
    "data-name": "Rectangle 397",
    width: 135.96,
    height: 29.449,
    rx: 4.665,
    transform: "translate(265.52 516.006)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1732",
    "data-name": "Path 1732",
    d: "M342.685,481.42H251.379a1.2,1.2,0,0,0-1.2,1.2v12.025a1.2,1.2,0,0,0,1.2,1.2h91.305a1.2,1.2,0,0,0,1.2-1.2V482.62a1.2,1.2,0,0,0-1.2-1.2",
    transform: "translate(21.877 42.098)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_398",
    "data-name": "Rectangle 398",
    width: 93.704,
    height: 14.424,
    rx: 1.103,
    transform: "translate(272.058 523.519)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1733",
    "data-name": "Path 1733",
    d: "M351.947,487.767a3.634,3.634,0,1,0-3.634,3.634,3.634,3.634,0,0,0,3.634-3.634",
    transform: "translate(30.141 42.336)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1734",
    "data-name": "Path 1734",
    d: "M351.947,487.767a3.634,3.634,0,1,0-3.634,3.634A3.634,3.634,0,0,0,351.947,487.767Z",
    transform: "translate(30.141 42.336)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1735",
    "data-name": "Path 1735",
    d: "M365.035,487.767A3.634,3.634,0,1,0,361.4,491.4a3.634,3.634,0,0,0,3.634-3.634",
    transform: "translate(31.285 42.336)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1736",
    "data-name": "Path 1736",
    d: "M365.035,487.767A3.634,3.634,0,1,0,361.4,491.4,3.634,3.634,0,0,0,365.035,487.767Z",
    transform: "translate(31.285 42.336)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1737",
    "data-name": "Path 1737",
    d: "M332.454,487.767a3.634,3.634,0,1,0-3.635,3.634,3.634,3.634,0,0,0,3.635-3.634",
    transform: "translate(28.436 42.336)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1738",
    "data-name": "Path 1738",
    d: "M332.454,487.767a3.634,3.634,0,1,0-3.635,3.634A3.634,3.634,0,0,0,332.454,487.767Z",
    transform: "translate(28.436 42.336)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_399",
    "data-name": "Rectangle 399",
    width: 125.641,
    height: 10.085,
    transform: "translate(270.679 545.455)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_400",
    "data-name": "Rectangle 400",
    width: 125.641,
    height: 10.085,
    transform: "translate(270.679 545.455)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1739",
    "data-name": "Path 1739",
    d: "M375.055,510.867H249.241a5.073,5.073,0,0,0-5.073,5.073v19.3a5.073,5.073,0,0,0,5.073,5.073H375.055a5.072,5.072,0,0,0,5.073-5.073v-19.3a5.073,5.073,0,0,0-5.073-5.073",
    transform: "translate(21.352 44.673)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_401",
    "data-name": "Rectangle 401",
    width: 135.96,
    height: 29.449,
    rx: 4.665,
    transform: "translate(265.52 555.54)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1740",
    "data-name": "Path 1740",
    d: "M342.685,517.775H251.379a1.2,1.2,0,0,0-1.2,1.2V531a1.2,1.2,0,0,0,1.2,1.2h91.305a1.2,1.2,0,0,0,1.2-1.2V518.974a1.2,1.2,0,0,0-1.2-1.2",
    transform: "translate(21.877 45.277)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_402",
    "data-name": "Rectangle 402",
    width: 93.704,
    height: 14.424,
    rx: 1.103,
    transform: "translate(272.058 563.053)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1741",
    "data-name": "Path 1741",
    d: "M351.947,524.122a3.634,3.634,0,1,0-3.634,3.634,3.634,3.634,0,0,0,3.634-3.634",
    transform: "translate(30.141 45.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1742",
    "data-name": "Path 1742",
    d: "M351.947,524.122a3.634,3.634,0,1,0-3.634,3.634A3.634,3.634,0,0,0,351.947,524.122Z",
    transform: "translate(30.141 45.515)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1743",
    "data-name": "Path 1743",
    d: "M365.035,524.122a3.634,3.634,0,1,0-3.634,3.634,3.634,3.634,0,0,0,3.634-3.634",
    transform: "translate(31.285 45.515)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1744",
    "data-name": "Path 1744",
    d: "M365.035,524.122a3.634,3.634,0,1,0-3.634,3.634A3.634,3.634,0,0,0,365.035,524.122Z",
    transform: "translate(31.285 45.515)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1745",
    "data-name": "Path 1745",
    d: "M332.454,524.122a3.634,3.634,0,1,0-3.635,3.634,3.634,3.634,0,0,0,3.635-3.634",
    transform: "translate(28.436 45.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1746",
    "data-name": "Path 1746",
    d: "M332.454,524.122a3.634,3.634,0,1,0-3.635,3.634A3.634,3.634,0,0,0,332.454,524.122Z",
    transform: "translate(28.436 45.515)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1747",
    "data-name": "Path 1747",
    d: "M60.144,337.045c-9.272-5.281-21.782-8.766-29.945-1.9-5.253,4.42-6.9,12.041-5.781,18.815s4.571,12.909,8.106,18.793c8.287,13.79,17.636,27.385,30.63,36.872s32.806,14.228,47.994,8.924c-2.176-33.32-21.989-64.983-51-81.508",
    transform: "translate(2.106 28.973)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1748",
    "data-name": "Path 1748",
    d: "M13.366,427.723c-3.816,1.625-7.548,3.734-10.181,6.939s-4,7.682-2.671,11.611c1.754,5.19,7.352,7.881,12.466,9.844,14.1,5.409,29,9.579,44.088,8.881s30.756-6.056,39.878-18.091c-11.848-9.335-24.6-17.8-39.2-21.586s-30.5-3.509-44.377,2.4",
    transform: "translate(0 36.974)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1749",
    "data-name": "Path 1749",
    d: "M99.691,273.189c-4.9-4.472-12.5-6.541-18.345-3.4-5.749,3.091-8.18,10.018-9.329,16.443A81.455,81.455,0,0,0,79.5,337.021C85.2,348.236,94.715,359.249,107.288,359c7.236-21.683,8.69-46.779,1.942-68.617-1.958-6.338-4.639-12.72-9.539-17.193",
    transform: "translate(6.189 23.46)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1750",
    "data-name": "Path 1750",
    d: "M144.344,290.608c-6.851.434-10.727,7.93-12.781,14.479-12.661,40.379-9.089,85.019,12.348,121.5,12.4-10.781,18.031-24.8,19.032-41.2,1.625-26.623,3.188-53.858-4.163-79.5-2.094-7.308-6.85-15.766-14.437-15.285",
    transform: "translate(10.865 25.411)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1751",
    "data-name": "Path 1751",
    d: "M232.026,379.872c-4.246-4.356-11.483-3.134-17.177-.991a87.68,87.68,0,0,0-52.018,55.163c7.342,4.788,22.091,3.894,30.122.382s14.629-9.578,20.979-15.621c6.98-6.645,13.988-13.568,18.3-22.185,2.672-5.335,3.955-12.475-.21-16.748",
    transform: "translate(14.239 32.962)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1752",
    "data-name": "Path 1752",
    d: "M141.1,500.541c-.2-1.351-.468-3.207-.81-5.558q-.276-1.82-.609-4.015c-.26-1.46-.624-3.033-.972-4.73-.746-3.384-1.432-7.279-2.665-11.469q-.858-3.163-1.792-6.613c-.637-2.3-1.491-4.627-2.271-7.073-1.5-4.916-3.58-9.995-5.671-15.377a251.991,251.991,0,0,0-17.078-33.428,251.773,251.773,0,0,0-22.261-30.214c-3.878-4.277-7.488-8.41-11.217-11.947-1.838-1.791-3.542-3.6-5.31-5.193l-5.114-4.56c-3.2-2.977-6.375-5.332-9.067-7.512-1.364-1.071-2.607-2.1-3.8-2.985l-3.319-2.34-4.61-3.21-1.214-.812a1.827,1.827,0,0,0-.432-.249,1.853,1.853,0,0,0,.374.334l1.155.895,4.493,3.36q1.478,1.091,3.26,2.405c1.171.907,2.395,1.955,3.736,3.044,2.653,2.217,5.791,4.6,8.946,7.606l5.053,4.593c1.749,1.605,3.432,3.418,5.25,5.215,3.69,3.548,7.263,7.688,11.107,11.964,2.913,3.435,5.857,7.083,8.783,10.917-.191-.094-.4-.2-.645-.311-1.06-.51-2.631-1.17-4.6-1.916a96.4,96.4,0,0,0-32.17-6.11c-2.1-.026-3.806.012-4.979.1a6.408,6.408,0,0,0-1.818.223c0,.16,2.6.161,6.772.394A125.85,125.85,0,0,1,73.8,387.925a126.08,126.08,0,0,1,15.776,4.112c2.821.934,4.836,1.676,5.8,1.978,4.435,5.836,8.825,12.107,13,18.794a258.694,258.694,0,0,1,17.077,33.255c2.106,5.351,4.213,10.4,5.736,15.286.795,2.43,1.664,4.747,2.318,7.028l1.849,6.575c1.274,4.165,2.006,8.037,2.8,11.4.374,1.688.764,3.25,1.052,4.7l.694,3.991c.068.376.13.719.194,1.069-.1-.184-.216-.393-.362-.651-.5-.837-1.164-2.12-2.188-3.668a104.528,104.528,0,0,0-9.384-12.6,113.052,113.052,0,0,0-41.7-30.247,113.066,113.066,0,0,0-50.839-8.258,104.347,104.347,0,0,0-15.554,2.226c-1.819.363-3.2.8-4.144,1.033a8.27,8.27,0,0,0-1.423.444,8.3,8.3,0,0,0,1.471-.246c.96-.172,2.35-.543,4.175-.846a117.769,117.769,0,0,1,15.521-1.9,111.274,111.274,0,0,1,19.075.506,29.478,29.478,0,0,0-2.987,1.485,38.5,38.5,0,0,0-15.49,16.68c-1.256,2.674-1.706,4.451-1.6,4.487.3.159,2.729-6.829,8.824-13.31a50.037,50.037,0,0,1,11.936-9.272,114.359,114.359,0,0,1,30.647,7.9,115.422,115.422,0,0,1,41.55,29.785,117.6,117.6,0,0,1,9.591,12.347c1.071,1.509,1.788,2.756,2.342,3.558.257.389.455.683.6.887.3,1.675.55,3.055.742,4.111.114.581.208,1.052.284,1.432a1.834,1.834,0,0,0,.132.484,1.917,1.917,0,0,0-.029-.5c-.049-.385-.11-.86-.185-1.447",
    transform: "translate(1.268 30.016)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1753",
    "data-name": "Path 1753",
    d: "M216.377,397.883l-3.424,1.945c-1.5.829-3.275,1.933-5.3,3.273-2.05,1.308-4.374,2.813-6.839,4.628l-3.905,2.8-4.109,3.2c-2.884,2.159-5.738,4.743-8.849,7.335a240.317,240.317,0,0,0-18.667,18.573,218.039,218.039,0,0,0-16.162,20.785c-2.14,3.437-4.35,6.6-6.049,9.777l-2.569,4.534-2.142,4.305c-.662,1.38-1.361,2.662-1.9,3.934s-1.035,2.466-1.509,3.593-.9,2.16-1.3,3.128l-.577,1.68.071-.311q.387-1.866,1.055-5.078c.908-4.414,2.113-10.821,3.485-18.76,2.749-15.872,6.009-37.918,8.012-62.435.972-12.262,1.513-23.972,1.75-34.626.1-6.289.112-12.2.035-17.648.933-1.49,2.712-4.8,4.655-8.7,2.688-5.4,4.664-9.878,4.415-10s-2.632,4.152-5.32,9.552c-1.631,3.279-3,6.21-3.766,8.042-.055-3.376-.146-6.57-.269-9.548-.1-4.029-.364-7.665-.539-10.861s-.389-5.944-.6-8.187q-.3-3.266-.476-5.166c-.061-.538-.11-.979-.15-1.341a1.588,1.588,0,0,0-.085-.453,1.567,1.567,0,0,0-.018.462c.014.364.03.808.05,1.35q.1,1.9.286,5.176c.148,2.247.315,4.995.425,8.191s.337,6.829.389,10.853c.241,8.044.26,17.629.033,28.266-.113,4.179-.272,8.527-.478,13-.523-1.489-3.021-6.666-6.183-12.766-3.714-7.164-6.925-12.869-7.173-12.741s2.562,6.042,6.276,13.2c3.435,6.628,6.434,11.993,7.063,12.663-.319,6.8-.751,13.9-1.33,21.2-2,24.476-5.144,46.507-7.71,62.4-1.282,7.946-2.378,14.37-3.167,18.8q-.55,3.231-.869,5.113c-.077.514-.141.935-.194,1.287l-.027.076c-.511,1.547-.921,2.79-1.235,3.741a7.053,7.053,0,0,0-.365,1.325,6.936,6.936,0,0,0,.558-1.259c.36-.934.829-2.152,1.413-3.67l1.006-2.653q.639-1.432,1.377-3.083.741-1.667,1.574-3.545c.554-1.256,1.272-2.522,1.951-3.885l2.189-4.253,2.607-4.482c1.721-3.146,3.946-6.272,6.1-9.677a228.775,228.775,0,0,1,16.146-20.635,254.024,254.024,0,0,1,18.529-18.547c2.64-2.228,5.091-4.439,7.533-6.4,1.248-.062,4.859-.661,9.161-.956,5.306-.389,9.635-.171,9.66-.466.035-.259-4.327-.936-9.732-.542a41.107,41.107,0,0,0-8.4,1.411c.176-.138.352-.287.529-.422l4.058-3.234,3.852-2.84c2.43-1.845,4.718-3.387,6.732-4.736,1.993-1.381,3.734-2.532,5.2-3.409l3.322-2.105a7.045,7.045,0,0,0,1.124-.795,7.013,7.013,0,0,0-1.227.619",
    transform: "translate(11.465 27.619)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1754",
    "data-name": "Path 1754",
    d: "M83.764,312.682c-.206.217,3.744,4.13,8.05,9.431,3.717,4.539,6.477,8.6,7.346,9.563,4.2,16.861,9.279,37,14.515,58.7,3.552,14.828,6.768,28.992,9.54,41.907,2.72,12.925,5.039,24.594,6.765,34.432.925,4.909,1.622,9.373,2.281,13.286.675,3.91,1.193,7.288,1.6,10.052.42,2.7.751,4.833.988,6.357.116.68.209,1.223.283,1.651a2.37,2.37,0,0,0,.131.558,2.394,2.394,0,0,0-.028-.572c-.048-.431-.108-.979-.183-1.664-.192-1.531-.461-3.669-.8-6.385-.345-2.775-.807-6.164-1.429-10.085-.607-3.925-1.254-8.4-2.135-13.321-1.638-9.862-3.888-21.554-6.558-34.5-2.724-12.936-5.916-27.117-9.468-41.952-7.154-29.65-14.127-56.365-19.026-75.74q-.935-3.7-1.775-7.028c.32-.345,1.142-3.969,1.9-8.43.8-4.72,1.231-8.584.956-8.631s-1.149,3.742-1.953,8.461a70.664,70.664,0,0,0-1.037,8.074c-1.57-6.215-2.885-11.421-3.889-15.393-.677-2.653-1.211-4.74-1.593-6.235-.182-.665-.326-1.2-.439-1.616a2.344,2.344,0,0,0-.184-.543,2.508,2.508,0,0,0,.083.567c.089.425.2.965.343,1.639.337,1.506.809,3.608,1.408,6.281,1.235,5.451,3.118,13.317,5.485,23.027,1.193,4.905,2.523,10.28,3.958,16.047a62.722,62.722,0,0,0-6.3-9.148c-4.36-5.365-8.664-8.989-8.833-8.793",
    transform: "translate(7.324 24.753)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1755",
    "data-name": "Path 1755",
    d: "M170.752,473.564l-11.934,62.762a8.8,8.8,0,0,1-8.642,7.154H114.919a8.8,8.8,0,0,1-8.68-7.358L95.865,473.564Z",
    transform: "translate(8.383 41.411)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1756",
    "data-name": "Path 1756",
    d: "M170.752,473.564l-11.934,62.762a8.8,8.8,0,0,1-8.642,7.154H114.919a8.8,8.8,0,0,1-8.68-7.358L95.865,473.564Z",
    transform: "translate(8.383 41.411)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1757",
    "data-name": "Path 1757",
    d: "M166.874,493.962H99.448l-3.583-20.4h74.887Z",
    transform: "translate(8.383 41.411)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1758",
    "data-name": "Path 1758",
    d: "M166.874,493.962H99.448l-3.583-20.4h74.887Z",
    transform: "translate(8.383 41.411)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1759",
    "data-name": "Path 1759",
    d: "M166.586,492.322l-1.414,7.437H100.193l-1.033-7.437Z",
    transform: "translate(8.671 43.052)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1760",
    "data-name": "Path 1760",
    d: "M166.586,492.322l-1.414,7.437H100.193l-1.033-7.437Z",
    transform: "translate(8.671 43.052)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1761",
    "data-name": "Path 1761",
    d: "M532.569,318.184s-1.335-5.846-4.764-5.434-2.343,1.546-5.61.675-3.916-3.64-5.523-1.233,1.422,3.939-1.457,3.654-4.04-2.043-5.174-.959a8.685,8.685,0,0,0-1.645,2.1l-.473,1.321a3.109,3.109,0,0,1,4.6-1.185c3.067,1.844,5.324,2.2,5.759.571s4.252-1.459,4.364-.524a4.826,4.826,0,0,0,1.2,2.068s-8.453.7-10.946,1-4.314-1.694-7.9,0-6.556,3.318-7.891,5.375,1.81,4.526,1.373,6.159-6.83,3.667-6.568,5.848,3.143,2.467.213,4.4-5.509,4.141-4.661,5.936,2.981,3.752,2.583,5.7-3.764,5.511-1.98,7.195,2.881.285,2.557,2.853-1.905,7.818.077,8.528,4.315,1.694,4.3,4.225-.41,4.476,1.335,5.847,5.835,1.2,6.285,4.935.911,4.949,2.582,5.7,4.289-1.148,5.6,1.855,5.088,2.867,6.882,2.017,3.2-2.283,4.863,1,3.6,3.677,6.022,2.753,5.959-.4,7.43,1.319,4.9,1.308,6.62-.164,2.94-4.464,4.488-2.121,5.274,4.425,6.607,2.367,2.205-5.324,4.3-3.68a4.428,4.428,0,0,0,6.2-1.061c1.059-1.708,3.366-3.567,5.933-3.243s5.723.26,5.659-2.895-.325-5.335,2.243-5.012,6.458,1.12,6.394-2.034-.288-5.025,1.582-5.25,4.724-2.781,4.188-4.614-1.948-8.3-1.012-8.415,2.193-2.794.883-5.8-1.609-5.5-.712-5.922,1.731-4-.438-6.27-3.019-4.064-1.3-5.535a4.164,4.164,0,0,0-.126-6.308c-2.132-1.956-3.256-3.4-3.443-4.961s-4.377-4.848-5.736-5.633-2.869-2.816-3.281-6.245-1.073-3.665-6.984-5.483a27.738,27.738,0,0,1-9.75-4.835c-2.408-1.607-8.329-.895-10.672.651s-11.569,1.076-15.07,8.769",
    transform: "translate(42.612 26.921)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1762",
    "data-name": "Path 1762",
    d: "M532.569,318.184s-1.335-5.846-4.764-5.434-2.343,1.546-5.61.675-3.916-3.64-5.523-1.233,1.422,3.939-1.457,3.654-4.04-2.043-5.174-.959a8.685,8.685,0,0,0-1.645,2.1l-.473,1.321a3.109,3.109,0,0,1,4.6-1.185c3.067,1.844,5.324,2.2,5.759.571s4.252-1.459,4.364-.524a4.826,4.826,0,0,0,1.2,2.068s-8.453.7-10.946,1-4.314-1.694-7.9,0-6.556,3.318-7.891,5.375,1.81,4.526,1.373,6.159-6.83,3.667-6.568,5.848,3.143,2.467.213,4.4-5.509,4.141-4.661,5.936,2.981,3.752,2.583,5.7-3.764,5.511-1.98,7.195,2.881.285,2.557,2.853-1.905,7.818.077,8.528,4.315,1.694,4.3,4.225-.41,4.476,1.335,5.847,5.835,1.2,6.285,4.935.911,4.949,2.582,5.7,4.289-1.148,5.6,1.855,5.088,2.867,6.882,2.017,3.2-2.283,4.863,1,3.6,3.677,6.022,2.753,5.959-.4,7.43,1.319,4.9,1.308,6.62-.164,2.94-4.464,4.488-2.121,5.274,4.425,6.607,2.367,2.205-5.324,4.3-3.68a4.428,4.428,0,0,0,6.2-1.061c1.059-1.708,3.366-3.567,5.933-3.243s5.723.26,5.659-2.895-.325-5.335,2.243-5.012,6.458,1.12,6.394-2.034-.288-5.025,1.582-5.25,4.724-2.781,4.188-4.614-1.948-8.3-1.012-8.415,2.193-2.794.883-5.8-1.609-5.5-.712-5.922,1.731-4-.438-6.27-3.019-4.064-1.3-5.535a4.164,4.164,0,0,0-.126-6.308c-2.132-1.956-3.256-3.4-3.443-4.961s-4.377-4.848-5.736-5.633-2.869-2.816-3.281-6.245-1.073-3.665-6.984-5.483a27.738,27.738,0,0,1-9.75-4.835c-2.408-1.607-8.329-.895-10.672.651S536.069,310.49,532.569,318.184Z",
    transform: "translate(42.612 26.921)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1763",
    "data-name": "Path 1763",
    d: "M472.6,471.777c10.089-7.815,31.427-43.242,31.427-43.242s2.575,18.092,5.569,26.729,7.061,14.3,6.042,24.224c0,.035-.088-1.533-.095-1.5l54.717,1.605c-1.675-3.019-2.745-3.577-2.995-4.893-.888-4.666,3.884-14.992,3.937-19.711s3.641-13.72,3.641-13.72,15.779,34.973,19.4,37.917,13.67,1.533,13.165-6.39c-.7-10.965-19-53.344-22.236-60.71s-7.295-12.486-15.112-11.738-9.629,2.106-14.958,2.4-2.975-25.3-2.975-25.3-8.394,7.383-19.328,2.958c0,0,1.373,13.443-.907,17.657s-3.467,5.536-8.916,3.639-13.981-8.343-19.188-5.853-41.762,63.308-44.619,68.5c-1.888,3.431-6.985,12.232-5.461,14.578Z",
    transform: "translate(39.65 33.007)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1764",
    "data-name": "Path 1764",
    d: "M472.6,471.777c10.089-7.815,31.427-43.242,31.427-43.242s2.575,18.092,5.569,26.729,7.061,14.3,6.042,24.224c0,.035-.088-1.533-.095-1.5l54.717,1.605c-1.675-3.019-2.745-3.577-2.995-4.893-.888-4.666,3.884-14.992,3.937-19.711s3.641-13.72,3.641-13.72,15.779,34.973,19.4,37.917,13.67,1.533,13.165-6.39c-.7-10.965-19-53.344-22.236-60.71s-7.295-12.486-15.112-11.738-9.629,2.106-14.958,2.4-2.975-25.3-2.975-25.3-8.394,7.383-19.328,2.958c0,0,1.373,13.443-.907,17.657s-3.467,5.536-8.916,3.639-13.981-8.343-19.188-5.853-41.762,63.308-44.619,68.5c-1.888,3.431-6.985,12.232-5.461,14.578Z",
    transform: "translate(39.65 33.007)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1765",
    "data-name": "Path 1765",
    d: "M510.641,471.4c.052-.51.083-1,.11-1.492l-.2-.005c.007-.036.09,1.533.094,1.5",
    transform: "translate(44.645 41.091)",
    fill: "#5ae4a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1766",
    "data-name": "Path 1766",
    d: "M510.641,471.4c.052-.51.083-1,.11-1.492l-.2-.005C510.554,469.87,510.637,471.439,510.641,471.4Z",
    transform: "translate(44.645 41.091)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1767",
    "data-name": "Path 1767",
    d: "M503.785,394.417c-5.207,2.489-41.762,63.309-44.619,68.5-1.888,3.43-6.985,12.232-5.461,14.577l18.893-7.148c10.089-7.817,31.427-43.243,31.427-43.243s2.575,18.093,5.57,26.729c2.839,8.193,6.637,13.717,6.151,22.733l54.513,1.6c-1.674-3.02-2.745-3.577-2.995-4.893-.887-4.667,3.884-14.993,3.938-19.711s3.641-13.721,3.641-13.721,15.778,34.974,19.4,37.917,13.669.3,13.877-6.588c.332-10.982-19.71-53.146-22.948-60.512s-7.295-12.485-15.113-11.737a60.8,60.8,0,0,0-8.3,1.344L539.1,427.848,522.973,400.27c-5.449-1.9-13.981-8.342-19.188-5.853",
    transform: "translate(39.65 34.441)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1768",
    "data-name": "Path 1768",
    d: "M503.785,394.417c-5.207,2.489-41.762,63.309-44.619,68.5-1.888,3.43-6.985,12.232-5.461,14.577l18.893-7.148c10.089-7.817,31.427-43.243,31.427-43.243s2.575,18.093,5.57,26.729c2.839,8.193,6.637,13.717,6.151,22.733l54.513,1.6c-1.674-3.02-2.745-3.577-2.995-4.893-.887-4.667,3.884-14.993,3.938-19.711s3.641-13.721,3.641-13.721,15.778,34.974,19.4,37.917,13.669.3,13.877-6.588c.332-10.982-19.71-53.146-22.948-60.512s-7.295-12.485-15.113-11.737a60.8,60.8,0,0,0-8.3,1.344L539.1,427.848,522.973,400.27C517.524,398.371,508.991,391.928,503.785,394.417Z",
    transform: "translate(39.65 34.441)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1769",
    "data-name": "Path 1769",
    d: "M513.569,467.413s-28.87,24.949-29.525,48.45c-.227,8.149,1.335,26.356,15.241,28.275s75.663,0,75.663,0,4.795-1.439,7.672-17.743S564.4,468.372,564.4,468.372Z",
    transform: "translate(42.326 40.873)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1770",
    "data-name": "Path 1770",
    d: "M513.569,467.413s-28.87,24.949-29.525,48.45c-.227,8.149,1.335,26.356,15.241,28.275s75.663,0,75.663,0,4.795-1.439,7.672-17.743S564.4,468.372,564.4,468.372Z",
    transform: "translate(42.326 40.873)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1771",
    "data-name": "Path 1771",
    d: "M531.544,476.553s-5.26,6.536-6.057,6.854-1.754,2.87-3.507,6.7-1.276,4.144.8,3.187,4.144-5.26,4.144-5.26l3.985-2.55s3.984-10.043.637-8.927",
    transform: "translate(45.551 41.665)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1772",
    "data-name": "Path 1772",
    d: "M531.544,476.553s-5.26,6.536-6.057,6.854-1.754,2.87-3.507,6.7-1.276,4.144.8,3.187,4.144-5.26,4.144-5.26l3.985-2.55S534.891,475.437,531.544,476.553Z",
    transform: "translate(45.551 41.665)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1773",
    "data-name": "Path 1773",
    d: "M584.172,461.268s-4.187,5.776-15.649,10.873-22.59,3.581-28.862,3.86-7.214-1.125-9.882,3.9-.3,18.8,1,19.689,1.454-5.47,1.454-5.47,1.152,6.108,2.979,6.215,2.409-5.2,2.409-5.2,1.613,3.761,3.1,3.256,1.182-4.515,1.182-4.515,1.8,2.371,2.687,1.074-1.247-9.178-1.247-9.178,8.125,1.331,11.1.32A9.808,9.808,0,0,0,559,482.745s14.785.054,23.769-1.413,18.569-11.069,18.555-16.6c-8.163,7.051-10.534.789-10.534.789",
    transform: "translate(46.221 40.336)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1774",
    "data-name": "Path 1774",
    d: "M584.172,461.268s-4.187,5.776-15.649,10.873-22.59,3.581-28.862,3.86-7.214-1.125-9.882,3.9-.3,18.8,1,19.689,1.454-5.47,1.454-5.47,1.152,6.108,2.979,6.215,2.409-5.2,2.409-5.2,1.613,3.761,3.1,3.256,1.182-4.515,1.182-4.515,1.8,2.371,2.687,1.074-1.247-9.178-1.247-9.178,8.125,1.331,11.1.32A9.808,9.808,0,0,0,559,482.745s14.785.054,23.769-1.413,18.569-11.069,18.555-16.6c-8.163,7.051-10.534.789-10.534.789",
    transform: "translate(46.221 40.336)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1775",
    "data-name": "Path 1775",
    d: "M540.994,492.207s-2.953-8.479-1.784-11.861",
    transform: "translate(47.128 42.004)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1776",
    "data-name": "Path 1776",
    d: "M537.025,493.476s-2-8.207-1.594-13.253",
    transform: "translate(46.817 41.994)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1777",
    "data-name": "Path 1777",
    d: "M532,492.358s-1.468-8.984-.488-10.976",
    transform: "translate(46.45 42.095)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1778",
    "data-name": "Path 1778",
    d: "M581.06,460.444a36.055,36.055,0,0,1-8.379,7.363c3.06,2.3,6.226,6.337,7.3,13.386,8.868-1.985,18.142-10.888,17.714-16.815",
    transform: "translate(50.079 40.264)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1779",
    "data-name": "Path 1779",
    d: "M581.06,460.444a36.055,36.055,0,0,1-8.379,7.363c3.06,2.3,6.226,6.337,7.3,13.386,8.868-1.985,18.142-10.888,17.714-16.815",
    transform: "translate(50.079 40.264)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1780",
    "data-name": "Path 1780",
    d: "M497.587,443.763a37.757,37.757,0,0,0,6.613-2.3c3.4-1.567,5.747-4.963,6.792-3.657s.289,3.693-1.683,5.373-7.721,4.554-7.721,4.554-6.2-1.2-4-3.969",
    transform: "translate(43.471 38.259)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1781",
    "data-name": "Path 1781",
    d: "M497.587,443.763a37.757,37.757,0,0,0,6.613-2.3c3.4-1.567,5.747-4.963,6.792-3.657s.289,3.693-1.683,5.373-7.721,4.554-7.721,4.554S495.389,446.531,497.587,443.763Z",
    transform: "translate(43.471 38.259)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1782",
    "data-name": "Path 1782",
    d: "M487.158,457.281s7.772-20.655,11.326-20.725,20.323,2.921,19.526,4.6-2.8,2.187-4.817,2.107-9.524-2.183-9.524-2.183l-2.2,2.768s7.747,2.218,8.943,2.788,5.789,5.1,4.638,6.9-1.64.981-1.64.981a4.748,4.748,0,0,1-.055,3.2c-.682,1.435-1.4,1.094-1.4,1.094a2.411,2.411,0,0,1-3.265,2.025c-1.746-.674-1.77-3.985-3.915-3.719-2.425.3-2.811-.125-2.811-.125a75.8,75.8,0,0,1-7.346,6.189,13.32,13.32,0,0,1-6.833,2.03s-14.3,12.042-26.4,13.553c-13.476,1.683-8.9-12.813-2.157-19.583s27.929-1.9,27.929-1.9",
    transform: "translate(39.587 38.175)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1783",
    "data-name": "Path 1783",
    d: "M487.158,457.281s7.772-20.655,11.326-20.725,20.323,2.921,19.526,4.6-2.8,2.187-4.817,2.107-9.524-2.183-9.524-2.183l-2.2,2.768s7.747,2.218,8.943,2.788,5.789,5.1,4.638,6.9-1.64.981-1.64.981a4.748,4.748,0,0,1-.055,3.2c-.682,1.435-1.4,1.094-1.4,1.094a2.411,2.411,0,0,1-3.265,2.025c-1.746-.674-1.77-3.985-3.915-3.719-2.425.3-2.811-.125-2.811-.125a75.8,75.8,0,0,1-7.346,6.189,13.32,13.32,0,0,1-6.833,2.03s-14.3,12.042-26.4,13.553c-13.476,1.683-8.9-12.813-2.157-19.583S487.158,457.281,487.158,457.281Z",
    transform: "translate(39.587 38.175)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1784",
    "data-name": "Path 1784",
    d: "M509.448,453.6s-2.575-4.23-4.243-5.024-7.156-1.615-7.156-1.615",
    transform: "translate(43.552 39.085)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1785",
    "data-name": "Path 1785",
    d: "M508.034,457.551s-3.956-5.785-5.2-5.863-5.281-.723-5.281-.723",
    transform: "translate(43.509 39.435)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1786",
    "data-name": "Path 1786",
    d: "M464.673,465.313c.543-4.7,3.464-8.677,5.866-11.221-4.535.184-8.869,1.1-11.309,3.555-6.741,6.768-11.317,21.265,2.157,19.583a32.214,32.214,0,0,0,8.076-2.283c-2.679-2.215-5.27-5.479-4.79-9.634",
    transform: "translate(39.587 39.709)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1787",
    "data-name": "Path 1787",
    d: "M464.673,465.313c.543-4.7,3.464-8.677,5.866-11.221-4.535.184-8.869,1.1-11.309,3.555-6.741,6.768-11.317,21.265,2.157,19.583a32.214,32.214,0,0,0,8.076-2.283C466.784,472.732,464.193,469.469,464.673,465.313Z",
    transform: "translate(39.587 39.709)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1788",
    "data-name": "Path 1788",
    d: "M558.868,377.6c1.048,4.578.259,8.665-1.763,9.127s-4.51-2.873-5.558-7.451-.259-8.665,1.763-9.127S557.82,373.025,558.868,377.6Z",
    transform: "translate(48.19 32.365)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1789",
    "data-name": "Path 1789",
    d: "M520.411,380.332c-.048,4.428-1.685,8-3.657,7.981s-3.534-3.629-3.486-8.057,1.684-8,3.657-7.981S520.458,375.9,520.411,380.332Z",
    transform: "translate(44.883 32.554)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1790",
    "data-name": "Path 1790",
    d: "M534.3,342.566s-4.591,1.093-4.636,4.6.474,4.7-2.208,5.784-4.125,1.969-3.707,4.445,1.5,3.248-1.9,3.823-3.15-1.7-3.867,1.607-.869,4.285-2.106,4.494.28,11.094,3.285,17.591,10.045,16.133,14.277,16.692,9.663-4.542,13.452-8.954c3.4-3.964,8.432-16.067,8.432-16.067l1.081-1.137s1.91,0,2.421-2.637c0,0-.37-4.076-2.436-5a10.205,10.205,0,0,1-4.344-5c-.157-.929.872-2.375-.523-3.095s-3.718-1.283-4.393-3.4,1.641-5.371-1.1-6.5-4.18-.25-4.547-2.416.817-4.594-1.249-5.52-5.933.683-5.933.683",
    transform: "translate(45.074 29.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1791",
    "data-name": "Path 1791",
    d: "M534.3,342.566s-4.591,1.093-4.636,4.6.474,4.7-2.208,5.784-4.125,1.969-3.707,4.445,1.5,3.248-1.9,3.823-3.15-1.7-3.867,1.607-.869,4.285-2.106,4.494.28,11.094,3.285,17.591,10.045,16.133,14.277,16.692,9.663-4.542,13.452-8.954c3.4-3.964,8.432-16.067,8.432-16.067l1.081-1.137s1.91,0,2.421-2.637c0,0-.37-4.076-2.436-5a10.205,10.205,0,0,1-4.344-5c-.157-.929.872-2.375-.523-3.095s-3.718-1.283-4.393-3.4,1.641-5.371-1.1-6.5-4.18-.25-4.547-2.416.817-4.594-1.249-5.52S534.3,342.566,534.3,342.566Z",
    transform: "translate(45.074 29.871)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1792",
    "data-name": "Path 1792",
    d: "M527.459,369.137c.326,1.931-.054,3.606-.85,3.741s-1.7-1.323-2.03-3.255.055-3.606.85-3.741,1.7,1.323,2.03,3.255",
    transform: "translate(45.862 31.994)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1793",
    "data-name": "Path 1793",
    d: "M540.5,369.341c-.021,1.958-.693,3.54-1.5,3.531s-1.443-1.6-1.422-3.562.693-3.54,1.5-3.531,1.443,1.6,1.422,3.562",
    transform: "translate(47.009 31.986)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1794",
    "data-name": "Path 1794",
    d: "M527.971,382.562s3.012,4.025,11.648.028",
    transform: "translate(46.169 33.454)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1795",
    "data-name": "Path 1795",
    d: "M519.8,364.3s4.313-4.536,9.463-1.6",
    transform: "translate(45.454 31.631)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1796",
    "data-name": "Path 1796",
    d: "M534.68,362.455s5.686-3.921,11.873,2.652",
    transform: "translate(46.756 31.594)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1797",
    "data-name": "Path 1797",
    d: "M529.476,373.735a5.691,5.691,0,0,0-.423,2.178c.129.768,1.33,3.2,3.891,2.766a3.257,3.257,0,0,0,2.637-4.658",
    transform: "translate(46.262 32.682)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1798",
    "data-name": "Path 1798",
    d: "M540.945,500.844a14.969,14.969,0,0,0-6.633,2.728c-8.94,6.549-6.64,21.33-6.949,31.12q-.581,18.46-1.187,36.92c-.6,18.093-.868,36.25-2.031,54.318-.893,13.856-4.791,35.446-1.815,50.181s10.72,11.5,14.858-2.1-1.569-40.075-2.061-46.066c-.382-4.662,21.032-75.31,26.779-107.3,2.126-11.835-10.14-21.454-20.96-19.8",
    transform: "translate(45.579 43.781)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1799",
    "data-name": "Path 1799",
    d: "M540.945,500.844a14.969,14.969,0,0,0-6.633,2.728c-8.94,6.549-6.64,21.33-6.949,31.12q-.581,18.46-1.187,36.92c-.6,18.093-.868,36.25-2.031,54.318-.893,13.856-4.791,35.446-1.815,50.181s10.72,11.5,14.858-2.1-1.569-40.075-2.061-46.066c-.382-4.662,21.032-75.31,26.779-107.3C564.031,508.81,551.765,499.19,540.945,500.844Z",
    transform: "translate(45.579 43.781)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1800",
    "data-name": "Path 1800",
    d: "M530.091,647.231c-3.935-.894-6.536-5.754-8.147-10.318-.829,9.57-1.208,19.405.385,27.285,2.976,14.734,10.719,11.5,14.857-2.1,1.559-5.128,1.719-12.087,1.288-19.087-2.066,2.813-4.861,5.022-8.382,4.221",
    transform: "translate(45.579 55.696)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1801",
    "data-name": "Path 1801",
    d: "M530.091,647.231c-3.935-.894-6.536-5.754-8.147-10.318-.829,9.57-1.208,19.405.385,27.285,2.976,14.734,10.719,11.5,14.857-2.1,1.559-5.128,1.719-12.087,1.288-19.087C536.407,645.822,533.612,648.031,530.091,647.231Z",
    transform: "translate(45.579 55.696)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1802",
    "data-name": "Path 1802",
    d: "M507.505,499.818a14.95,14.95,0,0,1,7.023,1.458c9.995,4.786,10.462,19.737,12.572,29.3q3.979,18.036,7.981,36.066c3.926,17.672,7.541,35.468,12.02,53.011,3.434,13.453,11.251,33.953,11.044,48.984s-8.414,13.28-14.99.675-5.853-39.674-6.476-45.655c-.485-4.652-34.568-70.135-46.12-100.514-4.274-11.241,6.007-22.958,16.947-23.329",
    transform: "translate(42.811 43.706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1803",
    "data-name": "Path 1803",
    d: "M507.505,499.818a14.95,14.95,0,0,1,7.023,1.458c9.995,4.786,10.462,19.737,12.572,29.3q3.979,18.036,7.981,36.066c3.926,17.672,7.541,35.468,12.02,53.011,3.434,13.453,11.251,33.953,11.044,48.984s-8.414,13.28-14.99.675-5.853-39.674-6.476-45.655c-.485-4.652-34.568-70.135-46.12-100.514C486.285,511.906,496.566,500.189,507.505,499.818Z",
    transform: "translate(42.811 43.706)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1804",
    "data-name": "Path 1804",
    d: "M543.46,641.982c3.7-1.605,5.361-6.861,6.1-11.643,2.58,9.252,4.768,18.849,4.659,26.886-.207,15.031-8.415,13.28-14.99.676-2.48-4.753-3.92-11.562-4.788-18.521,2.55,2.384,5.7,4.039,9.018,2.6",
    transform: "translate(46.735 55.121)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1805",
    "data-name": "Path 1805",
    d: "M543.46,641.982c3.7-1.605,5.361-6.861,6.1-11.643,2.58,9.252,4.768,18.849,4.659,26.886-.207,15.031-8.415,13.28-14.99.676-2.48-4.753-3.92-11.562-4.788-18.521C536.992,641.764,540.146,643.419,543.46,641.982Z",
    transform: "translate(46.735 55.121)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_403",
    "data-name": "Rectangle 403",
    width: 93.958,
    height: 58.37,
    transform: "translate(522.46 485.223)",
    fill: "#eeebef"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_404",
    "data-name": "Rectangle 404",
    width: 93.958,
    height: 58.37,
    transform: "translate(522.46 485.223)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_405",
    "data-name": "Rectangle 405",
    width: 93.958,
    height: 3.375,
    transform: "translate(522.46 542.259)",
    fill: "#cbc4ce"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_406",
    "data-name": "Rectangle 406",
    width: 93.958,
    height: 3.375,
    transform: "translate(522.46 542.259)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1806",
    "data-name": "Path 1806",
    d: "M370.012,466.019h81.2a16.312,16.312,0,0,0,16.312-16.312V280.738",
    transform: "translate(32.356 24.549)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1807",
    "data-name": "Path 1807",
    d: "M139.645,162V93.324a16.312,16.312,0,0,1,16.312-16.312h287.5a16.312,16.312,0,0,1,16.312,16.312v18.94",
    transform: "translate(12.211 6.734)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1,
    strokeDasharray: "2 2"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1212);
export default __webpack_public_path__ + "static/media/Group_1212.21d49f27e2d586e06f257d337ffc742d.svg";
export { ForwardRef as ReactComponent };